import _ from 'lodash'

export default {
  methods: {
    lazyClick: _.debounce(function (callback, args) {
      if (typeof callback !== 'function') {
        return
      }
      return callback(args)
    }, 1000, {leading:true, trailing:false})
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js